import React, { useState } from "react";

import moment from "moment";
import { EuiPagination, EuiPanel, EuiFlexGroup, EuiFlexItem, EuiText } from "@elastic/eui";
import _ from "lodash";
import driverMarkerIcon from "../../../assets/images/location-marker.png";

import * as S from "../style";
import trackAnalytics from "../../../trackAnalytics";

export default function MonitoringView({
    drivers,
    pageIndex,
    pageCount,
    totalDriversCount,
    Map,
    goToPage,
}) {
    const [selectedDriverId, setSelectedDriverId] = useState(null);

    const [center, setCenter] = useState([31.28701, 30.08885]);
    const [zoom, setZoom] = useState([10]);

    const sortDrivers = (drivers) =>
        _.orderBy(drivers, ["isOnline", "lastContactedAt"], ["desc", "desc"]);

    const handleDriverClick = (driver) => {
        trackAnalytics("monitoring clicks");
        setCenter([driver.currentLon, driver.currentLat]);
        setZoom([14]);
        setSelectedDriverId(driver.id);
    };

    return (
        <S.Wrapper>
            <S.DriverList>
                <h4 className="driver-list__title">{totalDriversCount} total drivers</h4>
                <S.DriverListWrapper>
                    {sortDrivers(drivers).map((driver) => (
                        <S.DriverCard>
                            <EuiPanel
                                onClick={() => handleDriverClick(driver)}
                                key={driver.id}
                            >
                                <EuiText>
                                    <div>
                                        <div className="driver-name">
                                            {driver.isOnline ? <S.OnlineIcon /> : <S.OfflineIcon />}
                                            {driver.name}
                                        </div>
                                        <div className="last-seen">
                                            {driver.lastContactedAt && "Last active "}
                                            {driver.lastContactedAt &&
                                                moment(driver.lastContactedAt).fromNow()}
                                        </div>
                                    </div>
                                </EuiText>
                            </EuiPanel>
                        </S.DriverCard>
                    ))}
                </S.DriverListWrapper>
                <EuiFlexGroup justifyContent="spaceAround">
                    <EuiFlexItem grow={false}>
                        <EuiPagination
                            aria-label="Drivers pagintaion"
                            activePage={pageIndex}
                            pageCount={pageCount}
                            onPageClick={(activePage) => goToPage(activePage)}
                        />
                    </EuiFlexItem>
                </EuiFlexGroup>
            </S.DriverList>
            {drivers.length && (
                <S.MapWrapper>
                    <Map
                        animationOptions={{
                            animate: true,
                        }}
                        style="mapbox://styles/hossamsaraya/ckg54m8sg3a2v19o84uxfpbw4"
                        center={center}
                        zoom={zoom}
                        containerStyle={{
                            height: "100%",
                            width: "100%",
                        }}
                    >
                        {drivers.map((driver) => (
                            <S.DriverMarker
                                onClick={() => handleDriverClick(driver)}
                                onMouseEnter={() => setSelectedDriverId(driver.id)}
                                onMouseLeave={() => setSelectedDriverId(null)}
                                key={driver.id}
                                isOnline={driver.isOnline}
                                coordinates={[driver.currentLon, driver.currentLat]}
                            >
                                {selectedDriverId === driver.id && (
                                    <S.DriverOverlay>{driver.name}</S.DriverOverlay>
                                )}
                                <img
                                    src={driverMarkerIcon}
                                    alt="driver marker icon"
                                />
                            </S.DriverMarker>
                        ))}
                    </Map>
                </S.MapWrapper>
            )}
        </S.Wrapper>
    );
}
